<!-- 质量管理 圆环图 -->
<template>
  <div>
    <div class="circle-wrapper">
      <div class="circle-content" :id="id"></div>
      <div class="title">{{title}}</div>
      <div class="content">
        <div class="sp1" :style="percent=='无数据'?'fontSize:14px;color:#e1e1eb':''">{{percent}}</div>
        <div class="sp2">{{unit}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["color", "percent", "id", "title", "content", "unit", "name1", "name2"],
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {
    const echarts = require("echarts");
    const myChart = echarts.init(document.getElementById(this.id));
    //console.log(this.content)
    //console.log(this.percent)
    let that = this
    const option = {
      tooltip: {
          trigger: 'item',
          position:'bottom',
          // formatter: '{a} <br/>{b}: {c}' + this.unit
          formatter: ()=>{
            var res=option.series[0].name+'<br />';
            var myseries=option.series;
            for(var i=0;i<myseries.length;i++){
                //在内部继续循环series[i],从data中判断：当地区名称等于params.name的时候就将当前数据和名称添加到res中供显示
                for(var k=0;k<myseries[i].data.length;k++){
                    // console.log(myseries);
                    //如果data数据中的name和地区名称一样
                    if(k==0){
                        //将series数据系列每一项中的name和数据系列中当前地区的数据添加到res中
                        res+=myseries[i].data[k].name+':'+myseries[i].data[k].value+that.unit+'<br />';
                    }else{
                      if(this.percent=='无数据'){
                        res+=myseries[i].data[k].name+':'+myseries[i].data[k].value+that.unit+'<br />';
                      }else{
                        res+=myseries[i].data[k].name+':'+(myseries[i].data[k].value+myseries[i].data[0].value)+that.unit+'<br />';
                      }
                    }
                }
            }
            //console.log(res)
            return res
          }
      },
      series: [
        {
          name: this.title,
          type: "pie",
          radius: ["70%", "100%"],
          avoidLabelOverlap: false,
          hoverAnimation: false,
          label: {
            show: false,
            position: "center",
          },
          emphasis: {
            label: {
              show: false,
              fontSize: '14',
              fontWeight: 'bold'
            },
          },
          labelLine: {
            show: false,
          },
          data: [
            {
              value: this.percent,
              name: this.name1,
              itemStyle: { color: this.color  },
            },
            {
              value: this.percent=='无数据'?this.content:this.content-this.percent,
              name: this.name2,
              itemStyle: { color: "#e1e1eb"},
            },
          ],
          animation: false
        },
      ],
    };
    myChart.setOption(option);
  },
  methods: {},
  components: {},
};
</script>

<style lang="scss" scoped="">
.circle-wrapper {
  position: relative;
  margin-left: 38px;
  margin-right: 38px;
}
.circle-content {
  width: 100px;
  height: 100px;
}
.title {
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #222222;
  font-size: 14px;
  line-height: 2;
  text-align: center;
  margin: 10px auto 10px;
}
.content {
  position: absolute;
  width: 100%;
  top: 32px;
  // left: 28px;
  text-align: center;
  .sp1 {
    font-size: 24px;
    font-weight: bold;
  }
  .sp2 {
    margin-left: 2px;
    font-size: 12px;
  }
}
</style>